/**
 * Floating Labels Component
 * Handles material UI style floating labels for form fields
 */

class FloatingLabels {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupFloatingLabels());
    } else {
      this.setupFloatingLabels();
    }
  }

  setupFloatingLabels() {
    // Find all field containers
    const fields = document.querySelectorAll('.field');
    
    console.log(`FloatingLabels: Found ${fields.length} field containers`);
    
    fields.forEach((field, index) => {
      const input = field.querySelector('.field__input');
      const label = field.querySelector('.field__label');
      
      if (!input || !label) {
        console.log(`FloatingLabels: Field ${index} missing input or label`);
        return;
      }
      
      console.log(`FloatingLabels: Setting up field ${index} with input type: ${input.type}`);
      
      // Set initial state based on input value
      this.updateLabelState(field, input);
      
      // Add event listeners
      input.addEventListener('focus', () => {
        console.log(`FloatingLabels: Focus on field ${index}`);
        this.handleFocus(field);
      });
      input.addEventListener('blur', () => {
        console.log(`FloatingLabels: Blur on field ${index}`);
        this.handleBlur(field, input);
      });
      input.addEventListener('input', () => {
        console.log(`FloatingLabels: Input on field ${index}, value: "${input.value}"`);
        this.handleInput(field, input);
      });
      
      // Handle autofill detection
      this.detectAutofill(field, input);
    });
  }

  handleFocus(field) {
    field.classList.add('field--js-focused');
  }

  handleBlur(field, input) {
    field.classList.remove('field--js-focused');
    this.updateLabelState(field, input);
  }

  handleInput(field, input) {
    this.updateLabelState(field, input);
  }

  updateLabelState(field, input) {
    const hasValue = input.value && input.value.trim() !== '';
    
    if (hasValue) {
      field.classList.add('field--js-filled');
    } else {
      field.classList.remove('field--js-filled');
    }
  }

  detectAutofill(field, input) {
    // Check for autofill on load and periodically
    const checkAutofill = () => {
      try {
        if (input.matches(':-webkit-autofill') || input.value !== '') {
          field.classList.add('field--js-filled');
        }
      } catch (e) {
        // Fallback for browsers that don't support :-webkit-autofill
        if (input.value !== '') {
          field.classList.add('field--js-filled');
        }
      }
    };

    // Check immediately
    setTimeout(checkAutofill, 100);
    
    // Check periodically for autofill
    const autofillInterval = setInterval(checkAutofill, 500);
    
    // Stop checking after 5 seconds
    setTimeout(() => clearInterval(autofillInterval), 5000);
  }
}

// Initialize floating labels
new FloatingLabels();

// Re-initialize when new content is added (for dynamic content)
document.addEventListener('shopify:section:load', () => {
  new FloatingLabels();
});